import React from 'react'
import { OverlaySpinner } from 'components/common'
import useScript from './useScript'

const GoogleAutoComplete = ({ children }) => {
  const isGoogleScriptLoaded = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_AUTO_COMPLETE_KEY}&libraries=places`
  )

  return <>{!isGoogleScriptLoaded ? <OverlaySpinner /> : children}</>
}

export default GoogleAutoComplete
